var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ai-recommendations-content" },
    [
      !_vm.hasNoData
        ? _c(
            "ol",
            _vm._l(_vm.sortedRecommendations, function(recommendation, index) {
              return _c(
                "li",
                { key: index, staticClass: "ai-recommendations-content__item" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "ai-recommendations-content__item-title typographies-paragraph-medium-semibold"
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(recommendation.title) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(recommendation.description))])
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasNoData
        ? _c("NoInvoicingData", {
            attrs: {
              content: _vm.$t.__("overview.tabs.TabSummary.noRecommendations")
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }